const referrerExists = () => {
  return traffic => {
    return traffic.referrer !== ''
  }
}

export default referrerExists



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/predicates/referrerExists.js